module.exports = __webpack_public_path__ + "static/media/BoxPlotQ3_1.a9134364.svg";